import { useEffect } from "react";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { RecentMusic } from "../components/RecentMusic";
import { AlbumFlipCards } from "../components/AlbumFlipCards";
import { FaithSection } from "../components/FaithSection";
import { CollabForm } from "../components/CollabForm";
import { PrayerForm } from "../components/PrayerForm";
import { Footer } from "../components/Footer";

export default function TekreckHome() {
  useEffect(() => {
    // Reveal on scroll
    const els = document.querySelectorAll(".fade-up");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in-view");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div data-testid="tekreck-home" className="min-h-screen bg-[#050505] text-white">
      <Navbar />
      <main>
        <Hero />
        <div className="fade-up"><RecentMusic /></div>
        <div className="fade-up"><AlbumFlipCards /></div>
        <div className="fade-up"><FaithSection /></div>
        <div className="fade-up"><CollabForm /></div>
        <div className="fade-up"><PrayerForm /></div>
      </main>
      <Footer />
    </div>
  );
}
